import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import { zIndexOverDrawer } from '../constants'
import { progressAnimation } from './constants'
import * as Styles from './styles'

const ImportProgressModal = ({ show, completed, onCancel, fileName }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Modal
      show={show}
      onClose={onCancel}
      title={t('Subiendo archivo')}
      size="m"
      zIndex={zIndexOverDrawer}
      blockOnClose
      actions={
        <Button fullWidth variant="outlined" onClick={onCancel} disabled={completed}>
          {t('Cancelar')}
        </Button>
      }
    >
      <Styles.Container>
        <Text type="bodyMRegular">{t('Procesando filas...')}</Text>
        <Styles.ProgressBar>
          <Styles.ProgressBarContent
            initial={{ width: '0%' }}
            animate={{
              width: `${completed ? progressAnimation.completedPercentage : progressAnimation.targetPercentage}%`,
            }}
            transition={{
              duration: completed ? progressAnimation.completedDurationInSeconds : progressAnimation.durationInSeconds,
              ease: completed ? 'easeOut' : progressAnimation.ease,
            }}
          />
        </Styles.ProgressBar>
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {fileName}
        </Text>
      </Styles.Container>
    </Modal>
  )
}

export default ImportProgressModal
